import { useLang } from "@/hooks/use-lang";
import {
  DateOption,
  allDateOptions,
  getDateOptionsToTextMap,
  getDisplayDateOptions,
  getTextToDateOptionMap,
} from "@/utils/date-options";

import { Select } from "ui/core/select";
import { ToggleButtons } from "ui/widget/toggle-buttons";

type Props = {
  dateOption: DateOption;
  onChange: (dateOption: DateOption) => void;
};

export const BacktestDateButtons = ({ dateOption, onChange }: Props) => {
  const { t } = useLang();
  const displayOptions = getDisplayDateOptions({ t, options: allDateOptions });
  const dateOptionToTextMap = getDateOptionsToTextMap({ t });
  const textToDateOptionMap = getTextToDateOptionMap({ t });

  return (
    <div className="text-end">
      <ToggleButtons
        className="gap-2.5"
        itemClassName="tracking-widest hidden @lg:inline-block bg-transparent rounded-lg text-zinc-500 text-sm font-bold hover:text-zinc-800"
        selectedItemClassName="bg-sky-100 shadow-none text-sky-600 hover:text-inset"
        options={displayOptions.map((option) => ({ value: option }))}
        value={dateOptionToTextMap[dateOption] || dateOption}
        onChange={(value) => {
          onChange(textToDateOptionMap[value] || value);
        }}
        fullWidth={false}
      />
      <Select
        value={dateOptionToTextMap[dateOption] || dateOption}
        options={displayOptions}
        className="inline-block max-w-[180px] @lg:hidden"
        onChange={(e) => {
          const value = e.target.value;
          onChange(textToDateOptionMap[value] || value);
        }}
      />
    </div>
  );
};
